import { useState, useEffect } from "react";

export function useFetch(fetchApi, setLoading) {
  const [data, setData] = useState(null);
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setData(null);
      try {
        const results = await fetchApi();
        setData(results);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    }
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return data;
}

export function useBulkFetch(fetchApiArray, setLoading) {
  const [data, setData] = useState(null);
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setData(null);
      try {
	let promises = []
	fetchApiArray.forEach(fetchApi => {
		promises.push(fetchApi());
	});
        const results = await Promise.all(promises);
        setData(results);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    }
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return data;
}
